<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1" id="ch00_fm02_tit"><a id="page_iii"></a><strong>Anna Seward and the End<br/>of the Eighteenth Century</strong></h1>
<p class="imaget"><img alt="image" src="images/common.jpg"/></p>
<p class="author"><span class="small">CLAUDIA THOMAS KAIROFF</span></p>
<p class="publisher"><img alt="image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02_tit.vue?bc420300